import { Download } from "lucide-react";
import { useSelector } from "react-redux";
import { timeStampToDateAndTime } from "../../../functions/dateTime/timeStampToDateAndTime";
import NoDataDisplay from "../../../components/UI/NoDataDisplay";

const GeneratedMonthlyList = () => {
  const sheetData = useSelector((state) => state.data.data);
  const BASE_IMAGE_URL = "https://jai-bharat-dev.s3.ap-south-1.amazonaws.com";

  const handleDownloadSheet = (sheetUrl) => {
    const urlSheet = BASE_IMAGE_URL + sheetUrl;
    // Validate image URL (optional)
    if (!sheetUrl || !urlSheet.startsWith("https")) {
      console.error(
        'Invalid image URL. Please provide a valid URL starting with "http" or "https".'
      );
      return;
    }

    // Create anchor element and set attributes
    const link = document.createElement("a");
    link.href = urlSheet;
    link.download = "urlSheet.split(" / ").pop()"; // Get filename from URL
    link.click();
  };

  return (
    <div className="bg-white p-4 rounded-lg relative mt-5 h-[calc(100vh-6em)] max-lg:h-[calc(100vh-5em)]">
      <div className="max-h-[760px] max-lg:h-[620px] overflow-scroll bg-white">
        <table className="w-full border-collapse text-center">
          <thead className="sticky top-0">
            <tr className="bg-dBlue-100 uppercase tracking-wide rounded-full text-dark-blue">
              <th className="px-4 py-2 rounded-l-full">SN</th>
              <th className="px-4 py-2">Created At</th>
              <th className="px-4 py-2 rounded-r-full">Download</th>
            </tr>
          </thead>
          {sheetData.length !== 0 ? (
            <tbody className="text-light-black">
              {sheetData.map((data, ind) => {
                return (
                  <>
                    <tr className="bg-white hover:bg-gray-50 border-b">
                      <td className="px-4 py-2">{ind + 1}</td>
                      <td className="px-4 py-2">
                        {timeStampToDateAndTime(data.createdAt)}
                      </td>
                      <td className="px-4 py-2">
                        <button
                          className="bg-teal-600 hover:bg-teal-500 px-3 py-[3px] text-white rounded-lg text-sm hover:text-white transition"
                          onClick={() => handleDownloadSheet(data.url)}
                        >
                          <Download />
                        </button>
                      </td>
                    </tr>
                  </>
                );
              })}
            </tbody>
          ) : (
            <NoDataDisplay />
          )}
        </table>
      </div>
    </div>
  );
};

export default GeneratedMonthlyList;